import React from 'react';

function China(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124160)">
        <mask
          id="mask0_800_124160"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124160)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V24H0V0Z"
            fill="#E31D1C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.8929 4.54832L15.7565 5.15815L16.0157 3.96812L15.0693 3.0775L16.3508 3.02935L16.8929 1.91815L17.4351 3.02935H18.7143L17.7701 3.96812L18.0544 5.15815L16.8929 4.54832Z"
            fill="#FECA00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.89494 9.60722L4.65401 11.1582L5.39324 8.13166L2.69434 5.86662L6.34881 5.74415L7.89494 2.91815L9.44108 5.74415H13.0893L10.3966 8.13166L11.2073 11.1582L7.89494 9.60722Z"
            fill="#FECA00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.1429 8.54832L18.0065 9.15815L18.2657 7.96812L17.3193 7.0775L18.6008 7.02935L19.1429 5.91815L19.6851 7.02935H20.9643L20.0201 7.96812L20.3044 9.15815L19.1429 8.54832Z"
            fill="#FECA00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.0179 12.5483L16.8815 13.1582L17.1407 11.9681L16.1943 11.0775L17.4758 11.0293L18.0179 9.91815L18.5601 11.0293H19.8393L18.8951 11.9681L19.1794 13.1582L18.0179 12.5483Z"
            fill="#FECA00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.6429 15.5483L13.5065 16.1582L13.7657 14.9681L12.8193 14.0775L14.1008 14.0293L14.6429 12.9182L15.1851 14.0293H16.4643L15.5201 14.9681L15.8044 16.1582L14.6429 15.5483Z"
            fill="#FECA00"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124160">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default China;
